// @flow
import {action, observable} from 'mobx'
import {Pagination} from './pagination'
import {notification} from 'antd'

import {Api} from 'Store/api'

export class List {
  api: Api
  type: string
  @observable data: {}[] = []
  @observable loading: boolean = false
  @observable pagination = new Pagination()
  @observable selected: string[] = []

  constructor(api: Api, type: string) {
    this.api = api
    this.type = type
  }

  @action async load(page: number = 1) {
    this.pagination.set('page', page)
    this.loading = true
    try {
      const type = `${this.type.replace(' ', '-')}s`
      const url = `sys/${type}?page=${page}`
      const {results, count} = await this.api.request(url, 'get')
      this.data = results
      this.pagination.set('count', count)
      if(Array.isArray(results)) {
        if (page === 1) {
          this.pagination.size = results.length
        }
      }
    } catch (e) {
      notification['error']({
        message: `Failed to load ${this.type} list`,
        description: e.message || 'Unknown error'
      })
    } finally {
      this.loading = false
    }
  }

  @action select(keys: string[]) {
    this.selected = keys
  }

  @action async deleteSelected() {
    this.loading = true
    try {
      const type = `${this.type.replace(' ', '-')}s`
      await this.api.request(`sys/${type}/delete`, 'post', {ids: this.selected})
      this.load()
    } catch (e) {
      notification['error']({
        message: `Failed to delete ${this.type}s`,
        description: e.message || 'Unknown error'
      })
      this.loading = false
    }
  }
}
